module.exports = __webpack_public_path__ + "img/pic_7.a88b0136.jpg";